import { API_ENDPOINT } from ".";

export type SubmitContactInput = {
  name: string;
  email: string;
  subject?: string;
  message: string;
  sourcePage?: string;
};

export type SubmitContactResult =
  | { ok: true }
  | { ok: false; message: string };

export async function submitContactAPI(
  input: SubmitContactInput,
): Promise<SubmitContactResult> {
  try {
    const response = await fetch(`${API_ENDPOINT}/contact`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: input.name.trim(),
        email: input.email.trim(),
        subject: input.subject?.trim() || undefined,
        message: input.message.trim(),
        sourcePage: input.sourcePage,
      }),
    });

    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      return {
        ok: false,
        message: body.error?.message ?? "Failed to send your message.",
      };
    }

    return { ok: true };
  } catch (err) {
    console.error(err);
    return { ok: false, message: "Network error. Please try again." };
  }
}
